module.exports = {
	"sliders": [
		{
			"url": "https://static.couponplatz.de/banner/38.png",
			"title": "",
			"link": "https://couponplatz.de/anleitung"
		},
		{
			"url": "https://static.couponplatz.de/banner/41.png",
			"title": ""
		},
		{
			"url": "https://static.couponplatz.de/banner/19.png",
			"title": ""
		},
		{
			"url": "https://static.couponplatz.de/banner/40.png",
			"title": ""
		},
		{
			"url": "https://static.couponplatz.de/banner/48.png",
			"title": ""
		},
		{
			"url": "https://static.couponplatz.de/banner/44.png",
			"title": ""
		},
		{
			"url": "https://static.couponplatz.de/banner/47.png",
			"title": ""
		}
	],
	"cards": [
		{
			"type": 1,
			"id": 100,
			"couponcode": 9812813250050,
			"facevalue": 50,
			"title": "Mövenpick Gourmet Aprikose",
			"condition": "beim Kauf einer 250g Packung Mövenpick Gourmet Aprikose.",
			"disclaimer": "Nicht in bar und nur in teilnehmenden Märkten in Deutschland einlösbar. Ggf. Produkte nicht jederzeit verfügbar. Nicht mit anderen Coupon-Aktionen kombinierbar.",
			"expires": "2017-04-09",
			"brand": {
				"name": "Mövenpick",
				"url": "https://static.couponplatz.de/brands/Moevenpick_Ausdruck.png"
			},
			"media": [
				{
					"type": "productshot_small",
					"url": "https://static.couponplatz.de/products/Moevenpick_Marmelade_Aprikose.png"
				},
				{
					"type": "brand_small",
					"url": "https://static.couponplatz.de/brands/Moevenpick.png"
				},
				{
					"type": "brand_large",
					"url": "https://static.couponplatz.de/brands/Moevenpick_Ausdruck.png"
				}
			],
			"tags": [],
			"acceptors": [
				41,
				75,
				32,
				114,
				115,
				53,
				51,
				1,
				142,
				88,
				94
			],
			"properties": []
		},
		{
			"type": 3,
			"id": 128,
			"media": [
				{
					"type": "card_image",
					"url": "https://static.couponplatz.de/misc/couponplatz_Kachel_Umfrage_032017.png"
				}
			],
			"properties": [
				{
					"key": "target",
					"value": "_blank"
				},
				{
					"key": "href",
					"value": "https://www.survio.com/survey/d/I9D1T5A5J8D7L6J9P"
				}
			]
		},
		{
			"type": 4,
			"id": 33,
			"media": [],
			"properties": []
		},
		{
			"type": 3,
			"id": 32,
			"media": [
				{
					"type": "card_image",
					"url": "https://static.couponplatz.de/misc/couponplatz_contact6.png"
				}
			],
			"properties": [
				{
					"key": "href",
					"value": "mailto:anna@couponplatz.de"
				}
			]
		},
		{
			"type": 1,
			"id": 116,
			"couponcode": 9812808030100,
			"facevalue": 100,
			"title": "Jever Fun",
			"condition": "beim Kauf eines Sixpacks Jever Fun (6x0,33l).",
			"disclaimer": "Nicht in bar und nur in teilnehmenden Märkten in Deutschland einlösbar. Ggf. Produkte nicht jederzeit verfügbar. Nicht mit anderen Coupon-Aktionen kombinierbar.",
			"expires": "2017-04-14",
			"brand": {
				"name": "Jever Fun",
				"url": "https://static.couponplatz.de/brands/Radeberger_Jever_Fun_Ausdruck.png"
			},
			"media": [
				{
					"type": "productshot_small",
					"url": "https://static.couponplatz.de/products/Radeberger_Jever_Fun.png"
				},
				{
					"type": "brand_small",
					"url": "https://static.couponplatz.de/brands/Radeberger_Jever_Fun.png"
				},
				{
					"type": "brand_large",
					"url": "https://static.couponplatz.de/brands/Radeberger_Jever_Fun_Ausdruck.png"
				}
			],
			"tags": [],
			"acceptors": [
				41,
				75,
				76,
				65,
				4,
				34,
				117,
				121,
				150,
				15,
				32,
				114,
				115,
				53,
				78,
				3,
				37,
				42,
				51,
				1,
				142,
				88,
				85,
				94,
				83,
				2,
				82,
				90,
				93,
				123,
				91,
				112
			],
			"properties": []
		},
		{
			"type": 1,
			"id": 94,
			"couponcode": 9812801090156,
			"facevalue": 150,
			"title": "Sourz",
			"condition": "beim Kauf einer beliebigen 0,7l Flasche Beam Sourz.",
			"disclaimer": "Nicht in bar und nur in teilnehmenden Märkten in Deutschland einlösbar. Ggf. Produkte nicht jederzeit verfügbar. Nicht mit anderen Coupon-Aktionen kombinierbar.",
			"expires": "2017-04-14",
			"brand": {
				"name": "Sourz",
				"url": "https://static.couponplatz.de/brands/Beam_Sourz_Ausdruck.png"
			},
			"media": [
				{
					"type": "productshot_small",
					"url": "https://static.couponplatz.de/products/Beam_Sourz.png"
				},
				{
					"type": "brand_small",
					"url": "https://static.couponplatz.de/brands/Beam_Sourz.png"
				},
				{
					"type": "brand_large",
					"url": "https://static.couponplatz.de/brands/Beam_Sourz_Ausdruck.png"
				}
			],
			"tags": [],
			"acceptors": [
				75
			],
			"properties": []
		},
		{
			"type": 2,
			"id": 61,
			"couponcode": 9823248010355,
			"facevalue": 35,
			"title": "Argeta Aufstrich",
			"condition": "beim Kauf einer beliebigen Dose Argeta Aufstrich.",
			"disclaimer": "Nicht in bar und nur in teilnehmenden Märkten in Deutschland einlösbar. Ggf. Produkte nicht jederzeit verfügbar. Nicht mit anderen Coupon-Aktionen kombinierbar.",
			"expires": "2017-04-14",
			"brand": {
				"name": "Adventsaktion",
				"url": "https://static.couponplatz.de/brands/Argeta_Logo_Ausdruck.png"
			},
			"media": [
				{
					"type": "coupon_image",
					"url": "https://static.couponplatz.de/argeta/Argeta_Highlight-Kachel_NoDate.png"
				},
				{
					"type": "brand_large",
					"url": "https://static.couponplatz.de/brands/Argeta_Logo_Ausdruck.png"
				},
				{
					"type": "productshot_small",
					"url": "https://static.couponplatz.de/products/Argeta_Aufstrich_Ansicht.png"
				},
				{
					"type": "brand_small",
					"url": "https://static.couponplatz.de/brands/Argeta_Logo_Ansicht.png"
				},
				{
					"type": "preview_tile_left",
					"url": "https://static.couponplatz.de/argeta/Argeta_Detail_Ansicht_Teil1_NoDate.png"
				},
				{
					"type": "preview_tile_middle",
					"url": "https://static.couponplatz.de/argeta/Argeta_Detail_Ansicht_Teil2_NoDate.png"
				},
				{
					"type": "preview_tile_right",
					"url": "https://static.couponplatz.de/argeta/Argeta_Detail_Ansicht_Teil3_NoDate.png"
				}
			],
			"tags": [],
			"acceptors": [
				76,
				65,
				4,
				15
			],
			"properties": []
		},
		{
			"type": 1,
			"id": 120,
			"couponcode": 9812801120051,
			"facevalue": 50,
			"title": "Zewa Toilettenpapier",
			"condition": "beim Kauf einer beliebigen Packung Zewa Toilettenpapier.",
			"disclaimer": "Nicht in bar und nur in teilnehmenden Märkten in Deutschland einlösbar. Ggf. Produkte nicht jederzeit verfügbar. Nicht mit anderen Coupon-Aktionen kombinierbar.",
			"expires": "2017-04-14",
			"brand": {
				"name": "Zewa",
				"url": "https://static.couponplatz.de/brands/SCA_Zewa_Ausdruck.png"
			},
			"media": [
				{
					"type": "brand_small",
					"url": "https://static.couponplatz.de/brands/SCA_Zewa.png"
				},
				{
					"type": "brand_large",
					"url": "https://static.couponplatz.de/brands/SCA_Zewa_Ausdruck.png"
				},
				{
					"type": "productshot_small",
					"url": "https://static.couponplatz.de/products/SCA_Zewa_ToiPa.png"
				}
			],
			"tags": [],
			"acceptors": [
				41,
				75,
				76,
				65,
				4,
				34,
				117,
				121,
				150,
				71,
				15,
				32,
				70,
				74,
				73,
				114,
				115,
				53,
				78,
				3,
				37,
				42,
				51,
				79,
				12,
				18,
				1,
				142,
				88,
				85,
				94,
				83,
				82
			],
			"properties": []
		},
		{
			"type": 1,
			"id": 92,
			"couponcode": 9823248190705,
			"facevalue": 70,
			"title": "hohes C hoch2",
			"condition": "beim Kauf einer beliebigen PET-Flasche hohes C hoch2 Smoothie oder Direktsaft.",
			"disclaimer": "Nicht in bar und nur in teilnehmenden Märkten in Deutschland einlösbar. Ggf. Produkte nicht jederzeit verfügbar. Nicht mit anderen Coupon-Aktionen kombinierbar.",
			"expires": "2017-04-14",
			"brand": {
				"name": "Hohes C Hoch 2",
				"url": "https://static.couponplatz.de/brands/granini_hohesC_hoch2_Ausdruck.png"
			},
			"media": [
				{
					"type": "brand_small",
					"url": "https://static.couponplatz.de/brands/granini_hohesC_hoch2.png"
				},
				{
					"type": "brand_large",
					"url": "https://static.couponplatz.de/brands/granini_hohesC_hoch2_Ausdruck.png"
				},
				{
					"type": "productshot_small",
					"url": "https://static.couponplatz.de/products/granini_hohesC_hoch2.png"
				}
			],
			"tags": [],
			"acceptors": [
				75,
				71,
				32,
				53,
				78,
				3,
				37,
				42,
				85,
				83,
				2,
				84
			],
			"properties": []
		},
		{
			"type": 1,
			"id": 105,
			"couponcode": 9812801090033,
			"facevalue": 30,
			"title": "Frosch Spülmittel",
			"condition": "beim Kauf einer 750ml Flasche Frosch Spülmittel.",
			"disclaimer": "Nicht in bar und nur in teilnehmenden Märkten in Deutschland einlösbar. Ggf. Produkte nicht jederzeit verfügbar. Nicht mit anderen Coupon-Aktionen kombinierbar.",
			"expires": "2017-04-09",
			"brand": {
				"name": "Frosch",
				"url": "https://static.couponplatz.de/brands/Frosch_Ausdruck.png"
			},
			"media": [
				{
					"type": "productshot_small",
					"url": "https://static.couponplatz.de/products/Frosch_Spuelmittel.png"
				},
				{
					"type": "brand_small",
					"url": "https://static.couponplatz.de/brands/Frosch.png"
				},
				{
					"type": "brand_large",
					"url": "https://static.couponplatz.de/brands/Frosch_Ausdruck.png"
				}
			],
			"tags": [],
			"acceptors": [
				75,
				32,
				73,
				114,
				115,
				53,
				3,
				37,
				42,
				51,
				1,
				142,
				88
			],
			"properties": []
		},
		{
			"type": 1,
			"id": 125,
			"couponcode": 9823248160401,
			"facevalue": 40,
			"title": "granini Trinkgenuss",
			"condition": "beim Kauf einer 1l PET-Flasche granini Trinkgenuss schwarze Johannisbeere.",
			"disclaimer": "Nicht in bar und nur in teilnehmenden Märkten in Deutschland einlösbar. Ggf. Produkte nicht jederzeit verfügbar. Nicht mit anderen Coupon-Aktionen kombinierbar.",
			"expires": "2017-04-14",
			"brand": {
				"name": "Granini Trinkgenuss",
				"url": "https://static.couponplatz.de/brands/granini_Trinkgenuss_Ausdruck.png"
			},
			"media": [
				{
					"type": "productshot_small",
					"url": "https://static.couponplatz.de/products/granini_Trinkgenuss_schw_Johannisbeere.png"
				},
				{
					"type": "brand_small",
					"url": "https://static.couponplatz.de/brands/granini_Trinkgenuss.png"
				},
				{
					"type": "brand_large",
					"url": "https://static.couponplatz.de/brands/granini_Trinkgenuss_Ausdruck.png"
				}
			],
			"tags": [],
			"acceptors": [
				75,
				32,
				78,
				51,
				88,
				83,
				93,
				91
			],
			"properties": []
		},
		{
			"type": 1,
			"id": 93,
			"couponcode": 9812801090200,
			"facevalue": 200,
			"title": "Brugal",
			"condition": "beim Kauf einer 0,7l Flasche Brugal Anejo oder Brugal XV Ron Reserva Exclusiva.",
			"disclaimer": "Nicht in bar und nur in teilnehmenden Märkten in Deutschland einlösbar. Ggf. Produkte nicht jederzeit verfügbar. Nicht mit anderen Coupon-Aktionen kombinierbar.",
			"expires": "2017-04-14",
			"brand": {
				"name": "Brugal",
				"url": "https://static.couponplatz.de/brands/Beam_Brugal_Ausdruck.png"
			},
			"media": [
				{
					"type": "productshot_small",
					"url": "https://static.couponplatz.de/products/Beam_Brugal.png"
				},
				{
					"type": "brand_small",
					"url": "https://static.couponplatz.de/brands/Beam_Brugal.png"
				},
				{
					"type": "brand_large",
					"url": "https://static.couponplatz.de/brands/Beam_Brugal_Ausdruck.png"
				}
			],
			"tags": [],
			"acceptors": [
				75
			],
			"properties": []
		},
		{
			"type": 1,
			"id": 112,
			"couponcode": 9812801220102,
			"facevalue": 100,
			"title": "8in1 Hauptfutter Hund",
			"condition": "beim Kauf einer beliebigen Packung 8in1 Hauptfutter Hund.",
			"disclaimer": "Nicht in bar und nur in teilnehmenden Märkten in Deutschland einlösbar. Ggf. Produkte nicht jederzeit verfügbar. Nicht mit anderen Coupon-Aktionen kombinierbar.",
			"expires": "2017-04-14",
			"brand": {
				"name": "8in1",
				"url": "https://static.couponplatz.de/brands/Tetra_8in1_Ausdruck.png"
			},
			"media": [
				{
					"type": "brand_small",
					"url": "https://static.couponplatz.de/brands/Tetra_8in1.png"
				},
				{
					"type": "brand_large",
					"url": "https://static.couponplatz.de/brands/Tetra_8in1_Ausdruck.png"
				},
				{
					"type": "productshot_small",
					"url": "https://static.couponplatz.de/products/Tetra_8in1_Hund.png"
				}
			],
			"tags": [],
			"acceptors": [
				75,
				76,
				65,
				4,
				34,
				71,
				15,
				73,
				142,
				83,
				2,
				90,
				93
			],
			"properties": []
		},
		{
			"type": 1,
			"id": 111,
			"couponcode": 9812801800052,
			"facevalue": 50,
			"title": "IAMS Katze Trockenfutter",
			"condition": "beim Kauf einer beliebigen Packung IAMS Katze Trockenfutter oder IAMS Naturally Katze Trockenfutter.",
			"disclaimer": "Nicht in bar und nur in teilnehmenden Märkten in Deutschland einlösbar. Ggf. Produkte nicht jederzeit verfügbar. Nicht mit anderen Coupon-Aktionen kombinierbar.",
			"expires": "2017-04-14",
			"brand": {
				"name": "IAMS",
				"url": "https://static.couponplatz.de/brands/Tetra_IAMS_Ausdruck.png"
			},
			"media": [
				{
					"type": "productshot_small",
					"url": "https://static.couponplatz.de/products/IAMS_Katze_Trockenfutter+IAMS_Naturally.png"
				},
				{
					"type": "brand_small",
					"url": "https://static.couponplatz.de/brands/Tetra_IAMS.png"
				},
				{
					"type": "brand_large",
					"url": "https://static.couponplatz.de/brands/Tetra_IAMS_Ausdruck.png"
				}
			],
			"tags": [],
			"acceptors": [
				75,
				76,
				65,
				4,
				34,
				121,
				71,
				15,
				32,
				73,
				142,
				2,
				90,
				93
			],
			"properties": []
		},
		{
			"type": 1,
			"id": 86,
			"couponcode": 9823248060206,
			"facevalue": 20,
			"title": "Zoo Original",
			"condition": "beim Kauf einer 200g Packung Leibniz Zoo Original.",
			"disclaimer": "Nicht in bar und nur in teilnehmenden Märkten in Deutschland einlösbar. Ggf. Produkte nicht jederzeit verfügbar. Nicht mit anderen Coupon-Aktionen kombinierbar.",
			"expires": "2017-04-09",
			"brand": {
				"name": "Zoo Original",
				"url": "https://static.couponplatz.de/brands/Leibniz_Ausdruck.png"
			},
			"media": [
				{
					"type": "productshot_small",
					"url": "https://static.couponplatz.de/products/Bahlsen_Leibniz_Zoo.png"
				},
				{
					"type": "brand_small",
					"url": "https://static.couponplatz.de/brands/Leibniz.png"
				},
				{
					"type": "brand_large",
					"url": "https://static.couponplatz.de/brands/Leibniz_Ausdruck.png"
				}
			],
			"tags": [],
			"acceptors": [
				41,
				32,
				73,
				114,
				115,
				53,
				3,
				37,
				42,
				51,
				1,
				88,
				94,
				39
			],
			"properties": []
		},
		{
			"type": 1,
			"id": 90,
			"couponcode": 9812801170100,
			"facevalue": 100,
			"title": "Landliebe",
			"condition": "beim Kauf von 6 Landliebe Produkten. Gilt nicht für Landliebe Konfitüre und Eiscreme.",
			"disclaimer": "Nicht in bar und nur in teilnehmenden Märkten in Deutschland einlösbar. Ggf. Produkte nicht jederzeit verfügbar. Nicht mit anderen Coupon-Aktionen kombinierbar.",
			"expires": "2017-04-14",
			"brand": {
				"name": "Landliebe",
				"url": "https://static.couponplatz.de/brands/Landliebe_Ausdruck.png"
			},
			"media": [
				{
					"type": "productshot_small",
					"url": "https://static.couponplatz.de/products/Landliebe_Range.png"
				},
				{
					"type": "brand_small",
					"url": "https://static.couponplatz.de/brands/Landliebe.png"
				},
				{
					"type": "brand_large",
					"url": "https://static.couponplatz.de/brands/Landliebe_Ausdruck.png"
				}
			],
			"tags": [],
			"acceptors": [
				41,
				75,
				76,
				65,
				4,
				34,
				117,
				121,
				150,
				71,
				15,
				114,
				115,
				53,
				3,
				37,
				42,
				51,
				79,
				1,
				142,
				88,
				85,
				94,
				83,
				2,
				90,
				39,
				93,
				123,
				100,
				112
			],
			"properties": []
		},
		{
			"type": 1,
			"id": 124,
			"couponcode": 9823248070304,
			"facevalue": 30,
			"title": "FruchtTiger",
			"condition": "beim Kauf einer beliebigen 0,5l PET-Sportscap Flasche FruchtTiger.",
			"disclaimer": "Nicht in bar und nur in teilnehmenden Märkten in Deutschland einlösbar. Ggf. Produkte nicht jederzeit verfügbar. Nicht mit anderen Coupon-Aktionen kombinierbar.",
			"expires": "2017-04-14",
			"brand": {
				"name": "FruchtTiger",
				"url": "https://static.couponplatz.de/brands/granini_FruchtTiger_Logo_Ausdruck.png"
			},
			"media": [
				{
					"type": "productshot_small",
					"url": "https://static.couponplatz.de/products/granini_FruchtTiger_Ansicht.png"
				},
				{
					"type": "brand_small",
					"url": "https://static.couponplatz.de/brands/granini_FruchtTiger_Logo_Ansicht.png"
				},
				{
					"type": "brand_large",
					"url": "https://static.couponplatz.de/brands/granini_FruchtTiger_Logo_Ausdruck.png"
				}
			],
			"tags": [],
			"acceptors": [
				41,
				75,
				76,
				65,
				71,
				15,
				32,
				74,
				73,
				114,
				115,
				51,
				79,
				1,
				142,
				88,
				85,
				83,
				2,
				82,
				84,
				93,
				100,
				91,
				112
			],
			"properties": []
		},
		{
			"type": 1,
			"id": 67,
			"couponcode": 9812801540057,
			"facevalue": 50,
			"title": "Hilcona Pasta Classica",
			"condition": "beim Kauf einer beliebigen Packung Hilcona Pasta Classica oder Gnocchi.",
			"disclaimer": "Nicht in bar und nur in teilnehmenden Märkten in Deutschland einlösbar. Ggf. Produkte nicht jederzeit verfügbar. Nicht mit anderen Coupon-Aktionen kombinierbar.",
			"expires": "2017-04-14",
			"brand": {
				"name": "Pasta Classica",
				"url": "https://static.couponplatz.de/brands/Hilcona_Logo_Ausdruck.png"
			},
			"media": [
				{
					"type": "productshot_small",
					"url": "https://static.couponplatz.de/products/Hilcona_Pasta_Ansicht.png"
				},
				{
					"type": "brand_small",
					"url": "https://static.couponplatz.de/brands/Hilcona_Logo_Ansicht.png"
				},
				{
					"type": "brand_large",
					"url": "https://static.couponplatz.de/brands/Hilcona_Logo_Ausdruck.png"
				}
			],
			"tags": [],
			"acceptors": [
				75,
				76,
				65,
				4,
				34,
				71,
				15,
				32,
				1,
				142,
				94,
				83,
				93
			],
			"properties": []
		},
		{
			"type": 1,
			"id": 123,
			"couponcode": 9823248040253,
			"facevalue": 25,
			"title": "Landliebe Drinks",
			"condition": "beim Kauf einer beliebigen Flasche Landliebe Landmilch, Trinkjoghurt oder Buttermilch.",
			"disclaimer": "Nicht in bar und nur in teilnehmenden Märkten in Deutschland einlösbar. Ggf. Produkte nicht jederzeit verfügbar. Nicht mit anderen Coupon-Aktionen kombinierbar.",
			"expires": "2017-04-14",
			"brand": {
				"name": "Landliebe",
				"url": "https://static.couponplatz.de/brands/Landliebe_Ausdruck.png"
			},
			"media": [
				{
					"type": "productshot_small",
					"url": "https://static.couponplatz.de/products/Landliebe_Drinks_Ansicht.png"
				},
				{
					"type": "brand_small",
					"url": "https://static.couponplatz.de/brands/Landliebe.png"
				},
				{
					"type": "brand_large",
					"url": "https://static.couponplatz.de/brands/Landliebe_Ausdruck.png"
				}
			],
			"tags": [],
			"acceptors": [
				76,
				65,
				4,
				34,
				71,
				15,
				114,
				115,
				53,
				3,
				37,
				42,
				51,
				79,
				142,
				88,
				85,
				83,
				2,
				90,
				93,
				123,
				100,
				112
			],
			"properties": []
		},
		{
			"type": 1,
			"id": 103,
			"couponcode": 9812813260059,
			"facevalue": 50,
			"title": "Rügenwalder Teewurst Grob oder Fein",
			"condition": "beim Kauf einer Packung Rügenwalder Teewurst Grob oder Fein.",
			"disclaimer": "Nicht in bar und nur in teilnehmenden Märkten in Deutschland einlösbar. Ggf. Produkte nicht jederzeit verfügbar. Nicht mit anderen Coupon-Aktionen kombinierbar.",
			"expires": "2017-04-09",
			"brand": {
				"name": "Teewurst",
				"url": "https://static.couponplatz.de/brands/Ruegenwalder_Ausdruck.png"
			},
			"media": [
				{
					"type": "productshot_small",
					"url": "https://static.couponplatz.de/products/Ruegenwalder_Teewurst.png"
				},
				{
					"type": "brand_small",
					"url": "https://static.couponplatz.de/brands/Ruegenwalder.png"
				},
				{
					"type": "brand_large",
					"url": "https://static.couponplatz.de/brands/Ruegenwalder_Ausdruck.png"
				}
			],
			"tags": [],
			"acceptors": [
				41,
				75,
				32,
				115,
				142,
				88,
				94
			],
			"properties": []
		},
		{
			"type": 1,
			"id": 109,
			"couponcode": 9823248101503,
			"facevalue": 150,
			"title": "Zendium Zahnpasta oder Mundspülung",
			"condition": "beim Kauf einer beliebigen Zendium Zahnpasta 75 ml oder Mundspülung 500 ml.",
			"disclaimer": "Nicht in bar und nur in teilnehmenden Märkten in Deutschland einlösbar. Ggf. Produkte nicht jederzeit verfügbar. Nicht mit anderen Coupon-Aktionen kombinierbar.",
			"expires": "2017-04-14",
			"brand": {
				"name": "Zendium",
				"url": "https://static.couponplatz.de/brands/Unilever_Zendium_Ausdruck.png"
			},
			"media": [
				{
					"type": "brand_small",
					"url": "https://static.couponplatz.de/brands/Unilever_Zendium_Ansicht.png"
				},
				{
					"type": "brand_large",
					"url": "https://static.couponplatz.de/brands/Unilever_Zendium_Ausdruck.png"
				},
				{
					"type": "productshot_small",
					"url": "https://static.couponplatz.de/products/Unilever_Zendium.png"
				}
			],
			"tags": [],
			"acceptors": [
				75,
				76,
				65,
				4,
				34,
				117,
				121,
				150,
				71,
				15,
				32,
				70,
				74,
				72,
				114,
				115,
				53,
				78,
				3,
				37,
				42,
				51,
				79,
				1,
				142,
				88,
				85,
				94,
				83,
				2,
				82,
				84,
				90
			],
			"properties": []
		},
		{
			"type": 1,
			"id": 91,
			"couponcode": 9823254100309,
			"facevalue": 30,
			"title": "Dr. Oetker Creme VEGA",
			"condition": "beim Kauf eines Bechers Dr. Oetker Creme VEGA.",
			"disclaimer": "Nicht in bar und nur in teilnehmenden Märkten in Deutschland einlösbar. Ggf. Produkte nicht jederzeit verfügbar. Nicht mit anderen Coupon-Aktionen kombinierbar.",
			"expires": "2017-04-14",
			"brand": {
				"name": "Dr. Oetker",
				"url": "https://static.couponplatz.de/brands/Dr.Oetker_Creme_Vega_Ausdruck.png"
			},
			"media": [
				{
					"type": "brand_small",
					"url": "https://static.couponplatz.de/brands/Dr.Oetker_Creme_Vega.png"
				},
				{
					"type": "brand_large",
					"url": "https://static.couponplatz.de/brands/Dr.Oetker_Creme_Vega_Ausdruck.png"
				},
				{
					"type": "productshot_small",
					"url": "https://static.couponplatz.de/products/Dr.Oetker_Creme_Vega.png"
				}
			],
			"tags": [],
			"acceptors": [
				75,
				76,
				65,
				4,
				34,
				15,
				114,
				115,
				78,
				142,
				2,
				82,
				90,
				123,
				112
			],
			"properties": []
		},
		{
			"type": 1,
			"id": 79,
			"couponcode": 9812813010203,
			"facevalue": 200,
			"title": "Pionier - glutenfreies Pilsener",
			"condition": "beim Kauf eines Viererpacks Pionier – glutenfreies Pilsener (4x0,33l).",
			"disclaimer": "Nicht in bar und nur in teilnehmenden Märkten in Deutschland einlösbar. Ggf. Produkte nicht jederzeit verfügbar. Nicht mit anderen Coupon-Aktionen kombinierbar.",
			"expires": "2017-04-14",
			"brand": {
				"name": "Pionier",
				"url": "https://static.couponplatz.de/brands/Radeberger_Pionier_Ausdruck.png"
			},
			"media": [
				{
					"type": "brand_small",
					"url": "https://static.couponplatz.de/brands/Radeberger_Pionier.png"
				},
				{
					"type": "brand_large",
					"url": "https://static.couponplatz.de/brands/Radeberger_Pionier_Ausdruck.png"
				},
				{
					"type": "productshot_small",
					"url": "https://static.couponplatz.de/products/Radeberger_Pionier.png"
				}
			],
			"tags": [],
			"acceptors": [
				75,
				76,
				65,
				4,
				34,
				15,
				32,
				78,
				142,
				94,
				83,
				2,
				82,
				93,
				112
			],
			"properties": []
		},
		{
			"type": 1,
			"id": 69,
			"couponcode": 9823248140403,
			"facevalue": 40,
			"title": "Die Limo von granini",
			"condition": "beim Kauf einer beliebigen 1,0 l Flasche Die Limo von granini.",
			"disclaimer": "Nicht in bar und nur in teilnehmenden Märkten in Deutschland einlösbar. Ggf. Produkte nicht jederzeit verfügbar. Nicht mit anderen Coupon-Aktionen kombinierbar.",
			"expires": "2017-04-14",
			"brand": {
				"name": "Die Limo",
				"url": "https://static.couponplatz.de/brands/granini_Die_Limo.png"
			},
			"media": [
				{
					"type": "brand_small",
					"url": "https://static.couponplatz.de/brands/granini_Die_Limo_Ansicht.png"
				},
				{
					"type": "brand_large",
					"url": "https://static.couponplatz.de/brands/granini_Die_Limo.png"
				},
				{
					"type": "productshot_small",
					"url": "https://static.couponplatz.de/products/granini_Die_Limo_Ansicht.png"
				}
			],
			"tags": [],
			"acceptors": [
				41,
				75,
				71,
				32,
				114,
				115,
				53,
				3,
				37,
				42,
				51,
				79,
				1,
				88,
				83,
				2,
				82,
				84,
				93,
				100,
				91,
				112
			],
			"properties": []
		}
	],
	"acceptors": [
		{
			"id": 41,
			"name": "Kaufland",
			"url": "https://static.couponplatz.de/acceptors/41_kaufland.png",
			"urlencoded_name": "kaufland",
			"ordinal": 1
		},
		{
			"id": 75,
			"name": "real,-",
			"url": "https://static.couponplatz.de/acceptors/75_real.png",
			"urlencoded_name": "real",
			"ordinal": 2
		},
		{
			"id": 76,
			"name": "EDEKA",
			"url": "https://static.couponplatz.de/acceptors/76_edeka.png",
			"urlencoded_name": "edeka",
			"ordinal": 3
		},
		{
			"id": 65,
			"name": "E center",
			"url": "https://static.couponplatz.de/acceptors/65_ecenter.png",
			"urlencoded_name": "e-center",
			"ordinal": 4
		},
		{
			"id": 4,
			"name": "E neukauf",
			"url": "https://static.couponplatz.de/acceptors/4_eneukauf.png",
			"urlencoded_name": "e-neukauf",
			"ordinal": 5
		},
		{
			"id": 34,
			"name": "Herkules",
			"url": "https://static.couponplatz.de/acceptors/34_herkules.png",
			"urlencoded_name": "herkules",
			"ordinal": 6
		},
		{
			"id": 117,
			"name": "REWE",
			"url": "https://static.couponplatz.de/acceptors/117_rewe.png",
			"urlencoded_name": "rewe",
			"ordinal": 7
		},
		{
			"id": 121,
			"name": "REWE Center",
			"url": "https://static.couponplatz.de/acceptors/121_rewe_center.png",
			"urlencoded_name": "rewe-center",
			"ordinal": 8
		},
		{
			"id": 150,
			"name": "REWE - Ihr kaufpark",
			"url": "https://static.couponplatz.de/acceptors/150_rewe_kaufpark.png",
			"urlencoded_name": "rewe-kaufpark",
			"ordinal": 9
		},
		{
			"id": 71,
			"name": "Globus",
			"url": "https://static.couponplatz.de/acceptors/71_globus.png",
			"urlencoded_name": "globus",
			"ordinal": 11
		},
		{
			"id": 15,
			"name": "Marktkauf",
			"url": "https://static.couponplatz.de/acceptors/15_marktkauf.png",
			"urlencoded_name": "marktkauf",
			"ordinal": 12
		},
		{
			"id": 32,
			"name": "HIT",
			"url": "https://static.couponplatz.de/acceptors/32_hit_echte_vielfalt.png",
			"urlencoded_name": "hit",
			"ordinal": 13
		},
		{
			"id": 70,
			"name": "Rossmann",
			"url": "https://static.couponplatz.de/acceptors/70_rossmann.png",
			"urlencoded_name": "rossmann",
			"ordinal": 14
		},
		{
			"id": 74,
			"name": "dm",
			"url": "https://static.couponplatz.de/acceptors/74_dm.png",
			"urlencoded_name": "dm",
			"ordinal": 15
		},
		{
			"id": 73,
			"name": "Müller",
			"url": "https://static.couponplatz.de/acceptors/73_mueller.png",
			"urlencoded_name": "mueller",
			"ordinal": 16
		},
		{
			"id": 72,
			"name": "BUDNI",
			"url": "https://static.couponplatz.de/acceptors/72_budni.png",
			"urlencoded_name": "budni",
			"ordinal": 17
		},
		{
			"id": 114,
			"name": "sky",
			"url": "https://static.couponplatz.de/acceptors/114_skysupermarkt.png",
			"urlencoded_name": "sky",
			"ordinal": 18
		},
		{
			"id": 115,
			"name": "sky XXL",
			"url": "https://static.couponplatz.de/acceptors/115_skyxxl.png",
			"urlencoded_name": "sky-xxl",
			"ordinal": 19
		},
		{
			"id": 53,
			"name": "famila",
			"url": "https://static.couponplatz.de/acceptors/53_famila_verbrauchermarkt.png",
			"urlencoded_name": "famila",
			"ordinal": 20
		},
		{
			"id": 78,
			"name": "famila Bartels-Langness",
			"url": "https://static.couponplatz.de/acceptors/78_famila_bartels_langness.png",
			"urlencoded_name": "famila-bartels-langness",
			"ordinal": 21
		},
		{
			"id": 3,
			"name": "Combi",
			"url": "https://static.couponplatz.de/acceptors/3_combi.png",
			"urlencoded_name": "combi",
			"ordinal": 22
		},
		{
			"id": 37,
			"name": "Jibi",
			"url": "https://static.couponplatz.de/acceptors/37_jibi.png",
			"urlencoded_name": "jibi",
			"ordinal": 23
		},
		{
			"id": 42,
			"name": "Minipreis",
			"url": "https://static.couponplatz.de/acceptors/42_minipreis.png",
			"urlencoded_name": "minipreis",
			"ordinal": 24
		},
		{
			"id": 51,
			"name": "Wasgau",
			"url": "https://static.couponplatz.de/acceptors/51_wasgau_2017.png",
			"urlencoded_name": "wasgau",
			"ordinal": 25
		},
		{
			"id": 79,
			"name": "tegut",
			"url": "https://static.couponplatz.de/acceptors/79_tegut.png",
			"urlencoded_name": "tegut",
			"ordinal": 28
		},
		{
			"id": 12,
			"name": "NP-Markt",
			"url": "https://static.couponplatz.de/acceptors/12_np.png",
			"urlencoded_name": "np-markt",
			"ordinal": 29
		},
		{
			"id": 18,
			"name": "Diska",
			"url": "https://static.couponplatz.de/acceptors/18_diska.png",
			"urlencoded_name": "diska",
			"ordinal": 31
		},
		{
			"id": 1,
			"name": "AEZ",
			"url": "https://static.couponplatz.de/acceptors/1_aez.png",
			"urlencoded_name": "aez",
			"ordinal": 32
		},
		{
			"id": 142,
			"name": "multi",
			"url": "https://static.couponplatz.de/acceptors/142_multi.png",
			"urlencoded_name": "multi",
			"ordinal": 35
		},
		{
			"id": 88,
			"name": "V-Markt",
			"url": "https://static.couponplatz.de/acceptors/88_vmarkt.png",
			"urlencoded_name": "v-markt",
			"ordinal": 36
		},
		{
			"id": 85,
			"name": "Klaas + Kock",
			"url": "https://static.couponplatz.de/acceptors/85_kk.png",
			"urlencoded_name": "klaas-kock",
			"ordinal": 37
		},
		{
			"id": 94,
			"name": "aktiv & irma",
			"url": "https://static.couponplatz.de/acceptors/94_aktiv_irma.png",
			"urlencoded_name": "aktiv-irma",
			"ordinal": 38
		},
		{
			"id": 83,
			"name": "akzenta",
			"url": "https://static.couponplatz.de/acceptors/83_akzenta.png",
			"urlencoded_name": "akzenta",
			"ordinal": 39
		},
		{
			"id": 2,
			"name": "CITTI",
			"url": "https://static.couponplatz.de/acceptors/2_citti.png",
			"urlencoded_name": "citti",
			"ordinal": 40
		},
		{
			"id": 82,
			"name": "Markant",
			"url": "https://static.couponplatz.de/acceptors/82_markant.png",
			"urlencoded_name": "markant",
			"ordinal": 41
		},
		{
			"id": 84,
			"name": "Markant Mein Supermarkt",
			"url": "https://static.couponplatz.de/acceptors/84_markant_buenting.png",
			"urlencoded_name": "markant-mein-supermarkt",
			"ordinal": 42
		},
		{
			"id": 90,
			"name": "SBK",
			"url": "https://static.couponplatz.de/acceptors/90_sbk.png",
			"urlencoded_name": "sbk",
			"ordinal": 43
		},
		{
			"id": 39,
			"name": "Kaiser´s Tengelmann",
			"url": "https://static.couponplatz.de/acceptors/39_kaisers_tengelmann.png",
			"urlencoded_name": "kaisers-tengelmann",
			"ordinal": 44
		},
		{
			"id": 93,
			"name": "EWS Kaufmarkt",
			"url": "https://static.couponplatz.de/acceptors/93_ews.png",
			"urlencoded_name": "ews",
			"ordinal": 45
		},
		{
			"id": 123,
			"name": "nah und gut Kissel",
			"url": "https://static.couponplatz.de/acceptors/123_kissel.png",
			"urlencoded_name": "kissel",
			"ordinal": 46
		},
		{
			"id": 100,
			"name": "Feneberg",
			"url": "https://static.couponplatz.de/acceptors/100_feneberg.png",
			"urlencoded_name": "feneberg",
			"ordinal": 48
		},
		{
			"id": 91,
			"name": "Vorteil Center",
			"url": "https://static.couponplatz.de/acceptors/91_vorteilcenter.png",
			"urlencoded_name": "vorteil-center",
			"ordinal": 49
		},
		{
			"id": 112,
			"name": "kaufmarkt",
			"url": "https://static.couponplatz.de/acceptors/112_kaufmarkt.png",
			"urlencoded_name": "kaufmarkt",
			"ordinal": 1000
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./src/assets/json/content.json
// module id = 228
// module chunks = 0